/* eslint-disable vars-on-top */
/* eslint-disable no-var */
/* eslint-disable no-use-before-define */
/* eslint-disable no-inner-declarations */
/* eslint-disable eqeqeq */
/* eslint-disable camelcase */
/* eslint-disable prefer-destructuring */
/* eslint-disable prefer-template */
/* eslint-disable no-plusplus */

$(document).ready(function () {
  try {
    $('.section--shipping-method .radio__input input:checked').parent().addClass('active');
    $('.section--shipping-method .radio__input input').on('change', function () {
      const $this = $(this);
      $('.radio__input').removeClass('active');
      $this.parent().addClass('active');
    });

    // customer information
    var checkout = $('.template-checkout');
    if (checkout.length > 0) {
      // Content may not be there yet on page load
      var checkShippingMethod = setInterval(checkingShippingMethod, 100);
      let intervals = 0;
      // Watch main content for changes to re-calculate shipping
      var observer = new MutationObserver(checkingShippingMethod);
      var observerConfig = { attributes: true, childList: true, subtree: true };
      var observed = [];

      function checkingShippingMethod() {
        intervals++;
        if (intervals > 1000) {
          clearInterval(checkShippingMethod);
          return;
        }
        // Main content may not be there on page load to set up the observer
        var mainContent = $('div.main__content');
        mainContent.each(function () {
          if (!observed.includes(this)) {
            observer.observe(this, observerConfig);
            observed.push(this);
          }
        });

        if ($('.step').length > 0) {
          var step = $('.step').data('step');
          if (typeof step != 'undefined') {
            if (step == 'shipping_method') {
              if ($('.radio-wrapper').length == 1) {
                var shipping_method = $('.radio-wrapper').data('shipping-method');

                var triggered = false;
                var str = '';
                var shipping_method_label = $(
                  '.radio-wrapper .radio__label span.radio__label__primary'
                ).text();
                if (shipping_method.search('blocking_method') != -1) {
                  triggered = true;
                }
                if (shipping_method.search('cannot_shipping') != -1) {
                  var shipping_method_labels = shipping_method_label.split('||');
                  var product_titles = 'this item';
                  if (shipping_method_labels.length > 1) {
                    // multiple, we should comma separate
                    if (shipping_method_labels[1].trim() != '') {
                      product_titles = shipping_method_labels[1];
                    }
                  }

                  str =
                    '<p>Sorry, ' +
                    product_titles +
                    " can't be shipped to your selected address. Please change the shipping address or remove the item(s) from your shopping cart.</p>";
                  triggered = true;
                } else if (shipping_method.search('call_shipping') != -1) {
                  str = '<p>Please call for Actual Shipping</p>';
                  triggered = true;
                }

                if (triggered) {
                  clearInterval(checkShippingMethod);

                  const footer = document.querySelector('.step__footer');

                  if (footer) {
                    footer.remove();
                  }
                  // try {
                  //   clearInterval(checkShippingMethod);
                  //   $('.step__footer button.step__footer__continue-btn')
                  //     .attr('disabled', true)
                  //     .addClass('btn--disabled');
                  // } catch (e) {
                  //   console.log('error', e);
                  // }
                }
              }
            } else {
              clearInterval(checkShippingMethod);
            }
          }
        }
      }
    }

    // displaySeasonWarningText();
    displayShippingDelayWarningText();
    initPhoneValidation();
    setTimeout(displayTaxExemptTooltip, 3000); // set time out to ensure tax calculations have loaded
  } catch (e) {
    Rollbar.error('checkout js', e);
  }
});

// Adding shipping info for customized products
if (typeof Checkout != 'undefined') {
  try {
    Checkout.$(document).on('page:load page:change', function () {
      if ($('.section--payment-method .content-box__row').length > 0) {
        $('.section--payment-method .content-box__row').each(function (i) {
          var gateway_group = $(this).data('gateway-group');
          if (gateway_group == 'manual') {
            $(this).hide();
          }
        });
      }
    });
  } catch (e) {
    Rollbar.error('shipping info for customized products', e);
  }
}

function displayShippingDelayWarningText() {
  if (!/checkouts/.test(window.location.href.split(/[?#]/)[0])) {
    return;
  }
  ['desktop', 'mobile'].forEach(function (_) {
    let wrapper;
    if (_ === 'desktop') {
      wrapper = document.querySelector('.order-summary__sections').closest('div');
    } else {
      wrapper = document.querySelector('.order-summary-toggle');
    }
    const specialTextEl = document.createElement('div');
    if (_ === 'mobile') {
      specialTextEl.style.padding = '1em';
    }
    // const content = `<p><b>Due to current events we are experiencing high demand for our products,
    // which is causing delays in seed packaging and delivery. Most orders are
    // shipping within 7-10 days after being placed. We are working very diligently to
    // package additional seed at this time. We do apologize for the delay in shipping
    // and we will get your order out as soon as possible.</b></p>`
    const checkoutJsonElement = document.querySelector('#checkout-json');
    let content = '';

    if (checkoutJsonElement) {
      const checkoutJson = JSON.parse(checkoutJsonElement.innerHTML);

      if (checkoutJson.checkoutNotice) {
        content = `<p class="checkout-notice">${checkoutJson.checkoutNotice}</p>`;
      }
    }

    specialTextEl.style.fontWeight = 'bold';
    specialTextEl.style.color = '#fff';
    specialTextEl.style.fontSize = 'medium';
    specialTextEl.innerHTML = content;

    wrapper.append(specialTextEl);
  });
}

function displaySeasonWarningText() {
  if (!/checkouts/.test(window.location.href.split(/[?#]/)[0])) {
    return;
  }
  const date = new Date();
  const currYear = date.getFullYear();

  const min = new Date(currYear, 10, 15);
  const max = new Date(currYear, 11, 31);

  if (date >= min && date <= max) {
    ['desktop', 'mobile'].forEach(function (_) {
      let wrapper;
      if (_ === 'desktop') {
        wrapper = document.querySelector('.order-summary__sections').closest('div');
      } else {
        wrapper = document.querySelector('.order-summary-toggle');
      }
      const specialTextEl = document.createElement('div');
      if (_ === 'mobile') {
        specialTextEl.style.padding = '1em';
      }
      const content = `<p>Please Note: We are changing over to the ${
        currYear + 1
      } season and your order
				may not ship immediately. Seed packages are being filled as soon as the current crop
				is ready.</p>
				<p>Most seed orders will ship within two weeks, but at this time we are unable
				to give an exact ship date.
				<p>If you have any special requirements or have questions,
				call us toll free at <a style="color: inherit" href="tel:1-800-626-0866">1-800-626-0866</a>, or email at <a style="color: inherit; text-decoration: underline;" href="mailto:info@territorialseed.com">info@territorialseed.com</a>.</p>`;
      specialTextEl.style.color = '#f1c148';
      specialTextEl.innerHTML = content;

      wrapper.append(specialTextEl);
    });
  }
}

function displayTaxExemptTooltip() {
  if (!/checkouts/.test(window.location.href.split(/[?#]/)[0])) {
    return;
  }
  const taxLine = $('[data-order-summary-section="payment-lines"]').find('[data-checkout-taxes]');
  if (!taxLine) {
    return;
  }
  const taxHeader = taxLine[0] && taxLine[0].querySelector('th');
  if (!taxHeader) return;
  const tooltip = constructToolTip();
  $(tooltip).appendTo(taxHeader);
}

function constructToolTip() {
  const tooltip = document.createElement('span');

  $(tooltip).css({
    position: 'relative',
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#2e7a3c',
    borderRadius: '50px',
    width: '15px',
    height: '15px',
    marginLeft: '5px',
    fontSize: '12px',
    fontStyle: 'italic',
    textAlign: 'center',
  });
  tooltip.textContent = 'i';

  const tooltipText = document.createElement('span');
  $(tooltipText).css({
    visibility: 'hidden',
    width: '340px',
    backgroundColor: '#fef9ec',
    color: '#000',
    borderRadius: '2px',
    padding: '10px',
    textAlign: 'left',
    fontStyle: 'normal',
    /* Position the tooltip */
    position: 'absolute',
    zIndex: '100',
    bottom: '100%',
    left: '50%',
    marginLeft: '-60px',
  });

  tooltipText.textContent =
    'Sales tax may be charged depending on your shipping location, as required by law. Tax exempt customers must submit the appropriate forms to us at least 5 business days prior to placing an order. An order placed without sending the appropriate forms will be charged tax, which cannot be refunded. Please submit forms to info@territorialseed.com.\n\nFor more information see our FAQ.';
  tooltip.append(tooltipText);

  $(tooltip).hover(
    function () {
      $(tooltipText).css('visibility', 'visible');
    },
    function () {
      $(tooltipText).css('visibility', 'hidden');
    }
  );
  return tooltip;
}

function isValidPhoneNumber(textInput) {
  // const re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
  // const re = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/;
  const re = /^\+?1?\s*?\(?\d{3}(?:\)|[-|\s])?\s*?\d{3}[-|\s]?\d{4}$/;

  return re.test(textInput);
}

function validatePhoneInput(event) {
  if (!event.target.id || event.target.id !== 'checkout_shipping_address_phone') {
    return;
  }

  let message = '';
  if (event.target.value && !isValidPhoneNumber(event.target.value)) {
    message = 'Please enter a valid phone number';
  }

  const inputWrapper = event.target.closest('.field__input-wrapper');
  if (!inputWrapper) return;

  let inputMessage = inputWrapper.querySelector('.input-message');

  if (!inputMessage) {
    inputMessage = document.createElement('div');
    inputMessage.classList.add('input-message');
    inputMessage = inputWrapper.appendChild(inputMessage);
  }

  inputMessage.innerHTML = message;
}

function initPhoneValidation() {
  document.body.addEventListener('change', validatePhoneInput);
  document.body.addEventListener('keyup', validatePhoneInput);
}
